/**
 * Returns true is the newer or legacy environment has accepted
 * the cookie wall based on a query parameter in the URL. Otherwise
 * it returns false.
 *
 * 'personalCookieConsent' is the newer parameter, 'hasAdConsent'
 * is for legacy sites which we must still support at this moment
 * in time.
 *
 * @returns {boolean}
 */
const personalAdConsent = () => {
  const params = new URLSearchParams(document.location.search);

  return (
    params.get('personalCookieConsent') === 'true' ||
    params.get('hasAdConsent') === '1'
  );
};

export default personalAdConsent;
